export const COMPLETE_BY_REQUIRED = "Complete by date is required";
export const COMPLETE_BY_INVALID = "Enter a valid date (MM/DD/YYYY)";
export const COMPLETE_BY_NOT_CURRENT_OR_FUTURE =
    "Complete by date must be today or a future date";

const US_DATE = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

export function todayIsoDateInUsEastern(now = new Date()): string {
    return new Intl.DateTimeFormat("en-CA", {
        timeZone: "America/New_York",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    }).format(now);
}

export function formatUsDate(isoDate: string): string {
    const match = ISO_DATE.exec(isoDate);
    if (!match) {
        return isoDate;
    }
    return `${match[2]}/${match[3]}/${match[1]}`;
}

export function isoDateFromInstant(value?: string | null): string {
    if (!value) {
        return "";
    }
    if (ISO_DATE.test(value)) {
        return value;
    }
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return "";
    }
    return todayIsoDateInUsEastern(date);
}

export function toDueAtPayload(isoDate: string): string {
    return `${isoDate}T12:00:00.000Z`;
}

function daysInMonth(year: number, month: number): number {
    return new Date(Date.UTC(year, month, 0)).getUTCDate();
}

export function parseCompleteByInput(raw: string): { isoDate: string } | { error: string } {
    const value = raw.trim();
    if (!value) {
        return { error: COMPLETE_BY_REQUIRED };
    }

    let year: number;
    let month: number;
    let day: number;

    const usMatch = US_DATE.exec(value);
    const isoMatch = ISO_DATE.exec(value);
    if (usMatch) {
        month = Number(usMatch[1]);
        day = Number(usMatch[2]);
        year = Number(usMatch[3]);
    } else if (isoMatch) {
        year = Number(isoMatch[1]);
        month = Number(isoMatch[2]);
        day = Number(isoMatch[3]);
    } else {
        return { error: COMPLETE_BY_INVALID };
    }

    if (month < 1 || month > 12 || day < 1 || day > daysInMonth(year, month)) {
        return { error: COMPLETE_BY_INVALID };
    }

    const isoDate = `${String(year).padStart(4, "0")}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
    if (isoDate < todayIsoDateInUsEastern()) {
        return { error: COMPLETE_BY_NOT_CURRENT_OR_FUTURE };
    }
    return { isoDate };
}

export function validateCompleteByInput(raw: string): string {
    const parsed = parseCompleteByInput(raw);
    return "error" in parsed ? parsed.error : "";
}
